import { render, staticRenderFns } from "./storeinfo.vue?vue&type=template&id=63f50a3f"
import script from "./storeinfo.vue?vue&type=script&lang=js"
export * from "./storeinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports